<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
      </div>
      <app-main />
    </div>
  </div>
</template>

<script>
// import RightPanel from '@/components/RightPanel'
import { AppMain, Navbar, Sidebar } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { mapState } from 'vuex';

export default {
    name: 'Layout',
    components: {
        AppMain,
        Navbar,
        // RightPanel,
        Sidebar
    },
    mixins: [ResizeMixin],
    computed: {
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device,
            fixedHeader: true
        }),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile'
            };
        }
    },
    methods: {
        handleClickOutside() {
            this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

  .app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }
  .main-container {
      width: calc(100% - 64px);
  }
  .sidebar-container {
      height: 100vh;
      background-color: #fff;
      border-right: solid 1px $issue-border;
  }
  .openSidebar {
      .sidebar-container {
          width: 210px;
          position: sticky;
          top: 0;
          overflow-y: auto;
          &::-webkit-scrollbar {
              width: 0px;
          }
      }
      .main-container {
          width: calc(100% - 210px);
      }
  }

  .mobile {
    .fixed-header {
      width: 100%;
    }
    .main-container {
      width: 100%;
    }
    .sidebar-container {
      width: 210px;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1001;
      transition: transform .28s;
      transform: translate3d(0, 0, 0);
    }
    &.hideSidebar .sidebar-container {
      pointer-events: none;
      transform: translate3d(-210px, 0, 0);
    }
  }
</style>
